module.exports = __webpack_public_path__ + "media/icons/add-24-d6102406.png";